<script>
import * as m from '@app/paraglide/messages.js';
import MenuItem from "../../menu/MenuItem.svelte";
function exit() {
    const ipcRenderer = window.ipcRenderer; 
    ipcRenderer.invoke('quit');
}
</script>
<MenuItem
    label={m.exit()}
    icon="bi-x-lg"
    id="exitMenuItem"
    onSelect={exit} />